import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { langType, surveyTypeValues } from '../../../constants/types';
import ModalDialog from '../../ModalDialog';
import { withLang } from '../../../i18n';
import LabelWrapper from '../../LabelWrapper';
import { Select } from '../../Select';
import { clearSurveySchemaOptionsAction, updateSurveySchemaOptionsAction } from '../../../actions';
import { routes } from '../../../constants';

const SelectSchemaTypeDialog = ({
  translate,
  dispatchClearSurveySchema,
  dispatchTypeUpdate
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedType, setSelectedType] = React.useState();
  const navigate = useNavigate();

  const handleCancel = () => setIsOpen(false);

  const handleConfirm = () => {
    dispatchClearSurveySchema();
    dispatchTypeUpdate(selectedType);
    navigate(routes.surveySchemas.schemas.create.index);
  };

  return (
    <>
      <button type="button" className="button--action icon--plus" onClick={() => setIsOpen(true)} data-cy="create-new-survey-schema-button">
        {translate('surveySchemas.createNew')}
      </button>
      <ModalDialog
        isOpen={isOpen}
        isLarge={false}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        cancelTranslationKey="common.cancel"
        confirmTranslationKey="common.continue"
        isValid={!!selectedType}
      >
        <h3>{translate('selectSchemaTypeDialog.title')}</h3>
        <LabelWrapper label={translate('selectSchemaTypeDialog.label')}>
          <Select
            options={Object.values(surveyTypeValues).map((type) => ({
              value: type,
              label: translate(`surveyType.${type}`)
            }))}
            placeholderKey="common.select"
            value={selectedType}
            onChange={(value) => setSelectedType(value)}
          />
        </LabelWrapper>
      </ModalDialog>
    </>
  );
};

SelectSchemaTypeDialog.propTypes = {
  dispatchClearSurveySchema: PropTypes.func.isRequired,
  dispatchTypeUpdate: PropTypes.func.isRequired,
  ...langType
};

const mapDispatchToProps = (dispatch) => ({
  dispatchClearSurveySchema: () => dispatch(clearSurveySchemaOptionsAction()),
  dispatchTypeUpdate: (type) => dispatch(updateSurveySchemaOptionsAction({ type }))
});

export default withLang(connect(null, mapDispatchToProps)(SelectSchemaTypeDialog));
